import { IAccount } from '@models/Account';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import AuthServiceApi from 'apis/api/Auth';
import DataManagementApi from 'apis/api/DataManagement';
import { IBranch } from 'models/Branch';
import { ICustomer } from 'models/Customer';
import { IOptionData } from 'models/OptionData';
import { IStaff } from 'models/Staff';
import { IStock } from 'models/Stock';
import { IProductCategory } from 'models/StockManage/CateProductManage';
import { ITechnicianZone } from 'models/TechnicianZone';
import { ITimeSelect } from 'models/TimeSelect';
import { IOrderSelect } from 'models/OrderSelect';
import moment from 'moment';
import { dark, light } from 'styles/Theme.styled';
import { getAllTypeOrders } from './createOrder.slice';
import ProductTransactionApi from 'apis/api/ProductTransaction';
import SupportTicketApi from 'apis/api/SupportTicket';
import DealerStatisticApi from 'apis/api/DealerStatistic';
import { IAssignedTag, ITicketTag } from 'models/SupportTicket';
import { IDealerLookup } from '@pages/Report/ThongKeHetPhi/models/DealerStatistic';
import { INotification } from '@components/common/NotifyFirebase/WapperNotification';

export const getAllBranch = createAsyncThunk('select/getAllBranch', async () => {
  const response = await DataManagementApi.GetAllBranch();
  return response.data;
});

export const getAssignedTag = createAsyncThunk('select/getAssignedTag', async () => {
  const response = await SupportTicketApi.GetAssignedTag();
  return response.data;
});

export const getStructureTags = createAsyncThunk('select/getStructureTags', async () => {
  const response = await SupportTicketApi.GetStuctureTag();
  return response.data;
});

export const getAllTechnicianZone = createAsyncThunk('select/getAllTechnicianZone', async () => {
  const response = await DataManagementApi.GetAllTechnicianZone();
  return response.data;
});

export const searchCustomersByPhone = createAsyncThunk('select/searchCustomersByPhone', async (textSearch: any) => {
  const response = await DataManagementApi.SearchCustomerByPhone(textSearch);
  return response.data;
});

export const searchCustomersByText = createAsyncThunk('select/searchCustomersByText', async (textSearch: any) => {
  const response = await DataManagementApi.SearchCustomer(textSearch);
  return response.data;
});

export const searchAdvanceSearchCustomerV2 = createAsyncThunk(
  'select/searchAdvanceSearchCustomerV2',
  async (dataBody: any) => {
    const response = await DataManagementApi.AdvanceSearchCustomerV2(dataBody);
    return response.data;
  }
);

export const getAdjustmentTypes = createAsyncThunk('select/getAdjustmentTypes', async () => {
  const response = await DataManagementApi.GetAdjustmentTypes();
  return response.data;
});

export const getUsersAccountant = createAsyncThunk('select/getUsersAccountant', async () => {
  const response = await AuthServiceApi.GetUsersByRoleV2('Accountant');
  return response.data;
});

export const getUsersSale = createAsyncThunk('select/getUsersSale', async () => {
  const response = await AuthServiceApi.GetUsersByRoleV2('Sale');
  return response.data;
});
export const getUsersWareHouse = createAsyncThunk('select/getUserWareHouse', async () => {
  const response = await AuthServiceApi.GetUsersByRoleV2('WareHouse');
  return response.data;
});

export const getUsersTechnician = createAsyncThunk('select/getUsersTechnician', async () => {
  const response = await AuthServiceApi.GetUsersByRoleV2('Technician');
  return response.data;
});

export const getAllUserSales = createAsyncThunk('adminConfig/getAllUserSales', async () => {
  const response = await AuthServiceApi.GetAllUserSales();
  return response.data;
});

export const getTypeAndState = createAsyncThunk('adminConfig/getTypeAndState', async () => {
  const response = await ProductTransactionApi.GetTypeAndState();
  return response.data;
});

// Danh mục dùng cho "Thống kê xe hết phí ở đại lý"
export const getListRegion = createAsyncThunk('select/getListRegion', async () => {
  const response = await DealerStatisticApi.GetListRegion();
  return response.data;
});

export const getListServer = createAsyncThunk('select/getListServer', async () => {
  const response = await DealerStatisticApi.GetListServer();
  return response.data;
});

export const getListDeviceType = createAsyncThunk('select/getListDeviceType', async () => {
  const response = await DealerStatisticApi.GetListDeviceType();
  return response.data;
});

interface ISelectLoadedData {
  orderLoaded?: boolean | null;
  branchLoaded?: boolean | null;
  technicianZoneLoaded?: boolean | null;
  techStaffLoaded?: boolean | null;
  adjustmentTypesLoaded?: boolean | null;
  salesListLoaded?: boolean | null;
  walletListLoaded?: boolean | null;
  saleStaffLoaded?: boolean | null;
  // deviceGroupLoadCompanyId: { companyId: number; groupId: number } | null;
  // pointSelectLoadCompanyId: number | null;
  structureTagsLoaded?: boolean | null;
  assignedTagLoaded?: boolean | null; // đã load StaffAssignTag (chi nhánh + tag được gán cho NV hiện tại) chưa
  regionLoaded?: boolean | null;
  serverLoaded?: boolean | null;
  deviceTypeLoaded?: boolean | null;
}

type initialStateType = {
  loadedData: ISelectLoadedData;
  customerSelectData: Array<ICustomer>; // danh sách khách hàng từ ô tìm kiếm nhanh KH của đơn hàng
  orderSelectData: Array<IOrderSelect>;
  techSelectData: Array<IStaff>;
  adjustmentTypesSelectData: Array<any>;
  walletStateArray: Array<any>;
  staffSelectData: Array<IStaff>;
  stockSelectData: Array<IStock>;
  branchSelectData: Array<IBranch>;
  technicianZoneSelectData: Array<ITechnicianZone>;

  // Danh mục "Thống kê xe hết phí ở đại lý"
  regionSelectData: Array<IDealerLookup>;
  serverSelectData: Array<IDealerLookup>;
  deviceTypeSelectData: Array<IDealerLookup>;

  // danh sách các tk user
  usersAccountant: Array<IAccount>;
  usersSale: Array<IAccount>;
  usersWareHouse: Array<IAccount>;
  usersTechnician: Array<IAccount>;
  salesListData: Array<any>;
  walletListState: Array<any>;
  walletListType: Array<any>;
  typeCoopData: Array<IOptionData>;
  vatData: Array<IOptionData>;

  selectedTime?: ITimeSelect;
  resetTime?: boolean;
  preSelectDate7?: ITimeSelect;

  selectedOrder?: IOrderSelect | undefined;
  selectedArrayOrder?: any;
  selectedArrayListSalesV2?: any;
  selectedArrayListSalesV3?: any;

  selectedBranch?: IBranch | undefined;
  listTechBranch?: any;
  listAccountantBranch?: any;
  listOperatingBranch?: any;

  selectedStatus?: string | undefined;
  orderCompanyName?: string | undefined;
  orderTypeCompany?: string | undefined;
  orderOperateCollected?: any | undefined;
  orderAccountCollected?: any | undefined;
  orderCoopType?: any | undefined;
  orderCoopTypeV2?: any | undefined;
  orderTime?: any | undefined;
  listOperatings?: any | undefined;
  listAccountants?: any | undefined;
  listSales?: any | undefined;
  listSalesV2?: any | undefined;
  isBlock?: any | undefined;
  paymentMethod?: any | undefined;
  walletState?: any | undefined;
  walletType?: any | undefined;
  adjustmentTypes?: any | undefined;

  supportTicketBranch?: any | undefined;
  supportTicketState?: any | undefined;
  assignedTag?: IAssignedTag | null;
  structureTags?: ITicketTag[]; // cây Tag/Category dùng chung cho màn CSKH
  activeTicketCode?: string;
  notifyTicket?: INotification | null; // thông báo của phiếu !! dùng để load dữ liệu phiếu

  typeBranch?: any | undefined;
  sender?: any | undefined;
  receiver?: any | undefined;
  selectedStock?: IStock;
  selectedStaff?: IStaff;
  selectedStaffTech?: any | undefined;
  categorySelect?: IProductCategory;
  selectedCustomer?: ICustomer;
  selectedMultipleStock?: Array<IOptionData>;
  selectedMultipleStaff?: Array<IOptionData>;
  selectedMultipleCustomer?: Array<IOptionData>;
  selectedMultipleCategory?: Array<IOptionData>;
  selectedMultipleOrder?: Array<IOptionData>;
  // lưu trữ theme trình duyệt
  themeSelected?: any;
  // thu gọn navbar menu
  isCollapsedNav?: any;
  // lưu trữ link menu đang chọn
  activeMenuHeader?: any;
  // btn trên menu header
  activeButtonHeader: string | undefined;
  // loading api
  isLoadingApi?: boolean;
  // hiện thông báo xác nhận chung...
  openConfirmModal?: boolean;
  // cấu hình json từ server
  configStart?: any;

  openCreateTicket?: boolean;

  forceReloadTicketData?: number;
};

const initialState: initialStateType = {
  customerSelectData: [],

  listTechBranch: [],
  listAccountantBranch: [],
  listOperatingBranch: [],
  techSelectData: [],
  adjustmentTypesSelectData: [],
  walletStateArray: [],
  staffSelectData: [],
  stockSelectData: [],
  orderSelectData: [],
  branchSelectData: [],
  regionSelectData: [],
  serverSelectData: [],
  deviceTypeSelectData: [],
  salesListData: [],
  walletListState: [],
  walletListType: [],
  technicianZoneSelectData: [],
  usersAccountant: [],
  usersSale: [],
  usersWareHouse: [],
  usersTechnician: [],
  typeCoopData: [
    { value: 1, label: ' Khách lẻ' },
    { value: 2, label: 'Công ty' },
    { value: 3, label: 'Đại lý' },
    { value: 4, label: 'HTX' },
    { value: 5, label: 'Showroom' },
    { value: 6, label: 'Cộng tác viên' }
  ],
  vatData: [
    {
      value: '0',
      label: 'Không rõ'
    },
    {
      value: '7',
      label: '7%'
    },
    {
      value: '10',
      label: '10%'
    }
  ],
  selectedTime: {
    beginTime: moment().startOf('day').toISOString(true),
    endTime: moment().endOf('day').toISOString(true)
  },
  resetTime: false,
  selectedMultipleStock: [],
  selectedMultipleStaff: [],
  selectedMultipleCustomer: [],
  selectedMultipleCategory: [],
  selectedMultipleOrder: [],
  activeTicketCode: null,
  themeSelected: dark,
  isCollapsedNav: false,
  activeButtonHeader: undefined,
  isLoadingApi: false,
  openConfirmModal: false,
  loadedData: {
    orderLoaded: null,
    branchLoaded: null,
    technicianZoneLoaded: null,
    techStaffLoaded: null,
    adjustmentTypesLoaded: null,
    salesListLoaded: null,
    walletListLoaded: null,
    assignedTagLoaded: null,
    structureTagsLoaded: null,
    regionLoaded: null,
    serverLoaded: null,
    deviceTypeLoaded: null
  },
  configStart: null,
  preSelectDate7: {
    beginTime: moment().add(-6, 'days').startOf('day').toISOString(true),
    endTime: moment().endOf('day').toISOString(true)
  },
  openCreateTicket: false,
  forceReloadTicketData: 0,
  notifyTicket: null
};

const selectSlide = createSlice({
  name: 'select',
  initialState: initialState,
  reducers: {
    resetState: state => {
      state.customerSelectData = [];
    },
    // select.slice.ts
    resetReportFilters: state => {
      console.log('resetReportFilters');

      state.selectedBranch = undefined;
      state.selectedTime = undefined;
      state.selectedOrder = undefined;
      state.selectedStatus = undefined;
      state.selectedArrayOrder = undefined;
      state.orderTime = undefined;
      state.resetTime = true; // để SingleSelect tự clear UI
    },
    updatePageLoadingApi: (state, action: PayloadAction<boolean>) => {
      state.isLoadingApi = action.payload;
    },
    updateOpenConfirmModal: (state, action: PayloadAction<boolean>) => {
      state.openConfirmModal = action.payload;
    },
    updateSelectDateTime: (state, action: PayloadAction<ITimeSelect>) => {
      // console.log('selectedTime change', action.payload);
      state.selectedTime = action.payload;
    },
    // ĐÁNH DẤU ĐỂ RESET DATETIME LỊCH
    updateResetDateTime: (state, action: PayloadAction<boolean>) => {
      state.resetTime = action.payload;
    },
    updateSelectDateTime7: (state, action: PayloadAction<ITimeSelect>) => {
      state.preSelectDate7 = action.payload;
    },
    updateSelectCustomer: (state, action: PayloadAction<string>) => {
      const result = state.customerSelectData.find(item => item.name === action.payload);
      state.selectedCustomer = result;
    },

    pushNotifyTicket: (state, action: PayloadAction<any>) => {
      state.notifyTicket = action.payload;
    },

    updateSelectStaff: (state, action: PayloadAction<string>) => {
      const result = state.techSelectData.find(item => item.username === action.payload);
      state.selectedStaff = result;
      state.selectedStaffTech = action.payload === '-1' ? undefined : action.payload;
    },
    // updateSelectWalletState: (state, action: PayloadAction<string>) => {
    //   const result = state.techSelectData.find(item => item.username === action.payload);
    //   state.selectedStaff = result;
    //   state.selectedStaffTech = action.payload === '-1' ? undefined : action.payload;
    // },
    // updateSelectCategory: (state, action: PayloadAction<string>) => {
    //   const result = state.categorySelectData.find(item => item.Name === action.payload);
    //   state.selectedCategory = result;
    // },
    updateSelectOrder: (state, action: PayloadAction<any>) => {
      if (action.payload?.type === 'mutiple') {
        state.selectedArrayOrder = action.payload;
      } else {
        const result = state.orderSelectData.find(item => item.id === action.payload);
        state.selectedOrder = result;
      }
    },

    updateSelectListSalesV2: (state, action: PayloadAction<any>) => {
      if (action.payload?.type === 'mutiple') {
        state.selectedArrayListSalesV2 = action.payload;
      }
      // else {
      //   const result = state.orderSelectData.find(item => item.id === action.payload);
      //   state.selectedOrder = result;
      // }
    },
    updateSelectListSalesV3: (state, action: PayloadAction<any>) => {
      state.selectedArrayListSalesV3 = action.payload === '-1' || !action.payload ? undefined : action.payload;
    },
    updateSelectStatus: (state, action: PayloadAction<string>) => {
      state.selectedStatus = action.payload === '-1' ? undefined : action.payload;
    },
    updateCompanyName: (state, action: PayloadAction<string>) => {
      state.orderCompanyName = action.payload === '-1' ? undefined : action.payload;
    },
    updateTypeCompany: (state, action: PayloadAction<string>) => {
      state.orderTypeCompany = action.payload === '-1' ? undefined : action.payload;
    },
    updateOperateCollected: (state, action: PayloadAction<string>) => {
      state.orderOperateCollected = action.payload === '-1' ? undefined : action.payload;
    },
    updateAccountCollected: (state, action: PayloadAction<string>) => {
      state.orderAccountCollected = action.payload === '-1' ? undefined : action.payload;
    },
    updateCoopType: (state, action: PayloadAction<string>) => {
      state.orderCoopType = action.payload === '-1' ? undefined : action.payload;
    },
    updateCoopTypeV2: (state, action: PayloadAction<any>) => {
      state.orderCoopTypeV2 = action.payload === '-1' ? undefined : action.payload;
    },
    updateTime: (state, action: PayloadAction<string>) => {
      state.orderTime = action.payload === 'TG Hoàn tất' ? undefined : action.payload;
    },
    updateListSales: (state, action: PayloadAction<string>) => {
      state.listSales = action.payload === '-1' ? undefined : action.payload;
    },
    updateListOperating: (state, action: PayloadAction<string>) => {
      state.listOperatings = action.payload === '-1' ? undefined : action.payload;
    },
    updateListAccountant: (state, action: PayloadAction<string>) => {
      state.listAccountants = action.payload === '-1' ? undefined : action.payload;
    },
    updateListSalesV2: (state, action: PayloadAction<any>) => {
      state.listSalesV2 = action.payload === '-1' ? undefined : action.payload;
    },
    updateIsBlock: (state, action: PayloadAction<any>) => {
      state.isBlock = action.payload === '-1' ? undefined : action.payload;
    },
    updateLPaymentMethod: (state, action: PayloadAction<string>) => {
      state.paymentMethod = action.payload === '-1' ? undefined : action.payload;
    },
    updateWallteState: (state, action: PayloadAction<any>) => {
      state.walletState = action.payload === '-1' ? undefined : action.payload;
    },
    updateWallteType: (state, action: PayloadAction<string>) => {
      state.walletType = action.payload === '-1' ? undefined : action.payload;
    },
    updateAdjustmentTypes: (state, action: PayloadAction<string>) => {
      state.adjustmentTypes = action.payload === '-1' ? undefined : action.payload;
    },
    updateSupportTicketBranch: (state, action: PayloadAction<string>) => {
      state.supportTicketBranch = action.payload === '-1' ? undefined : action.payload;
    },
    updateSupportTicketState: (state, action: PayloadAction<string>) => {
      state.supportTicketState = action.payload === '-1' ? undefined : action.payload || 'New';
    },
    updateSender: (state, action: PayloadAction<string>) => {
      state.sender = action.payload === '-1' ? undefined : action.payload;
    },
    updateReceiver: (state, action: PayloadAction<string>) => {
      state.receiver = action.payload === '-1' ? undefined : action.payload;
    },
    updateTypeBranch: (state, action: PayloadAction<string>) => {
      state.typeBranch = action.payload === 'CN thực hiện' ? undefined : action.payload;
    },
    updateSelectBranch: (state, action: PayloadAction<any>) => {
      const result = state.branchSelectData.find(item => item.id === action.payload);
      state.selectedBranch = result;
    },
    updateListTechBranch: (state, action: PayloadAction<any>) => {
      state.listTechBranch = action.payload || [];
    },
    updateListAccountantBranch: (state, action: PayloadAction<any>) => {
      state.listAccountantBranch = action.payload || [];
    },
    updateListOperatingBranch: (state, action: PayloadAction<any>) => {
      state.listOperatingBranch = action.payload || [];
    },
    updateSelectStock: (state, action: PayloadAction<string>) => {
      const result = state.stockSelectData.find(item => item.Name === action.payload);
      state.selectedStock = result;
    },
    updateSelectMultipleStock: (state, action: PayloadAction<IOptionData[]>) => {
      state.selectedMultipleStock = action.payload;
    },

    updateSelectMultipleStaff: (state, action: PayloadAction<IOptionData[]>) => {
      state.selectedMultipleStaff = action.payload;
    },

    updateSelectMultipleCustomer: (state, action: PayloadAction<IOptionData[]>) => {
      state.selectedMultipleCustomer = action.payload;
    },
    updateSelectMultipleCategory: (state, action: PayloadAction<IOptionData[]>) => {
      state.selectedMultipleCategory = action.payload;
    },
    updateSelectMultipleOrder: (state, action: PayloadAction<IOptionData[]>) => {
      state.selectedMultipleOrder = action.payload;
    },
    updateThemeSelected: (state, action: PayloadAction<any | undefined>) => {
      state.themeSelected = action.payload;
    },
    updateIsCollapseNav: (state, action: PayloadAction<boolean>) => {
      state.isCollapsedNav = action.payload;
    },
    // DÙNG ĐỂ TÔ MÀU MENU
    updateActiveMenuHeader: (state, action: PayloadAction<any | undefined>) => {
      state.activeMenuHeader = action.payload;
    },
    updateActiveButtonHeader: (state, action: PayloadAction<string | undefined>) => {
      state.activeButtonHeader = action.payload;
    },
    updateConfigStart: (state, action: PayloadAction<any | undefined>) => {
      state.configStart = action.payload;
    },
    updateActiveTicketCode: (state, action: PayloadAction<any | string>) => {
      state.activeTicketCode = action.payload;
    },
    updateOpenCreateTicket: (state, action: PayloadAction<boolean>) => {
      state.openCreateTicket = action.payload;
    },

    updateForceReloadTicketData: (state, action: PayloadAction<number>) => {
      state.forceReloadTicketData = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(getAssignedTag.fulfilled, (state, action) => {
      console.log('addCase getAssignedTag');
      state.assignedTag = action.payload?.data || null;
      state.loadedData.assignedTagLoaded = true;
    });

    // extraReducers, đặt cạnh getAssignedTag.fulfilled
    builder.addCase(getStructureTags.fulfilled, (state, action) => {
      state.structureTags = action.payload?.data?.tags || [];
      state.loadedData.structureTagsLoaded = true;
    });
    builder.addCase(getAllTypeOrders.fulfilled, (state, action) => {
      console.log('addCase getAllTypeOrders', action.payload?.data);
      state.orderSelectData = action.payload?.data || [];
      state.loadedData.orderLoaded = true;
    });
    builder.addCase(getAllBranch.fulfilled, (state, action) => {
      console.log('addCase getAllBranch', action.payload?.data);
      state.branchSelectData = action.payload?.data;
      state.loadedData.branchLoaded = true; // đã load chi nhánh đầu
    });
    builder.addCase(getAllTechnicianZone.fulfilled, (state, action) => {
      console.log('addCase getAllTechnicianZone');
      state.technicianZoneSelectData = action.payload?.data || [];
      state.loadedData.technicianZoneLoaded = true; // đã load chi nhánh đầu
    });
    builder.addCase(searchCustomersByPhone.fulfilled, (state, action) => {
      console.log('addCase searchCustomersByPhone');
      state.customerSelectData = (action.payload?.data && [action.payload?.data]) || [];
    });
    builder.addCase(searchCustomersByText.fulfilled, (state, action) => {
      console.log('addCase searchCustomersByText');
      state.customerSelectData = (action.payload?.data && action.payload?.data) || [];
    });

    builder.addCase(searchAdvanceSearchCustomerV2.fulfilled, (state, action) => {
      console.log('addCase searchAdvanceSearchCustomerV2');
      state.customerSelectData = (action.payload?.data && action.payload?.data) || [];
    });
    builder.addCase(getAdjustmentTypes.fulfilled, (state, action) => {
      console.log('addCase getAdjustmentTypes');
      state.adjustmentTypesSelectData = (action.payload?.data && action.payload?.data) || [];
      state.loadedData.adjustmentTypesLoaded = true;
    });
    builder.addCase(getUsersAccountant.fulfilled, (state, action) => {
      console.log('addCase getUsersAccountant');
      state.usersAccountant = action.payload?.data || [];
    });
    builder.addCase(getUsersSale.fulfilled, (state, action) => {
      console.log('addCase getUsersSale');
      state.usersSale = action.payload?.data || [];
      state.loadedData.saleStaffLoaded = true;
    });
    builder.addCase(getUsersWareHouse.fulfilled, (state, action) => {
      console.log('addCase getUserWareHouse');
      state.usersWareHouse = action.payload?.data || [];
    });
    builder.addCase(getUsersTechnician.fulfilled, (state, action) => {
      console.log('addCase getUsersTechnician');
      state.usersTechnician = action.payload?.data || [];
      state.techSelectData = action.payload?.data || [];
      state.loadedData.techStaffLoaded = true;
    });
    builder.addCase(getAllUserSales.fulfilled, (state, action) => {
      console.log('addCase getAllUserSales');
      // state.usersTechnician = action.payload?.data || [];
      state.salesListData = action.payload?.data || [];
      state.loadedData.salesListLoaded = true;
    });
    builder.addCase(getTypeAndState.fulfilled, (state, action) => {
      console.log('addCase getTypeAndState', action.payload);
      // state.usersTechnician = action.payload?.data || [];
      state.walletListState = action.payload?.data || [];
      state.walletListType = action.payload?.data || [];
      state.loadedData.walletListLoaded = true;
    });
    builder.addCase(getListRegion.fulfilled, (state, action) => {
      state.regionSelectData = action.payload?.data || [];
      state.loadedData.regionLoaded = true;
    });
    builder.addCase(getListServer.fulfilled, (state, action) => {
      state.serverSelectData = action.payload?.data || [];
      state.loadedData.serverLoaded = true;
    });
    builder.addCase(getListDeviceType.fulfilled, (state, action) => {
      state.deviceTypeSelectData = action.payload?.data || [];
      state.loadedData.deviceTypeLoaded = true;
    });
  }
});

export const {
  resetState,
  updateOpenConfirmModal,
  updatePageLoadingApi,
  updateSelectDateTime,
  resetReportFilters,
  // RESET LỊCH
  updateResetDateTime,
  updateSelectCustomer,
  updateSelectStaff,
  updateSelectStock,
  updateSelectOrder,
  updateSelectListSalesV2,
  updateSelectListSalesV3,
  updateSelectBranch,
  updateListTechBranch,
  updateListAccountantBranch,
  updateListOperatingBranch,
  updateSelectStatus,
  // updateSelectCategory,
  updateSelectMultipleStock,
  updateSelectMultipleStaff,
  updateSelectMultipleCustomer,
  updateSelectMultipleCategory,
  updateSelectMultipleOrder,
  updateThemeSelected,
  updateIsCollapseNav,
  updateActiveMenuHeader,
  updateActiveButtonHeader,
  updateConfigStart,
  updateCompanyName,
  updateTypeCompany,
  updateOperateCollected,
  updateAccountCollected,
  updateCoopType,
  updateCoopTypeV2,
  updateTime,
  updateListSales,
  updateListOperating,
  updateListAccountant,
  updateListSalesV2,
  updateIsBlock,
  updateLPaymentMethod,
  updateWallteState,
  updateWallteType,
  updateAdjustmentTypes,
  updateSender,
  updateReceiver,
  updateTypeBranch,
  updateSelectDateTime7,

  // Hỗ trợ CSKH
  updateSupportTicketBranch,
  updateSupportTicketState,
  updateActiveTicketCode,
  updateOpenCreateTicket,
  updateForceReloadTicketData,
  pushNotifyTicket
} = selectSlide.actions;

export default selectSlide.reducer;
